import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { getProduct } from "@/lib/products";
import AgenteVoiceIA from "@/pages/AgenteVoiceIA";

export const Route = createFileRoute("/agente-voice-ia")({
  head: () => buildHead({
    title: `${getProduct("agente-voice-ia")!.name} — OP2P CRM e Agentes de IA`,
    description: `${getProduct("agente-voice-ia")!.tagline} ${getProduct("agente-voice-ia")!.description}`,
    path: "/agente-voice-ia",
  }),
  component: AgenteVoiceIA,
});
